module.exports = "h1 {\n    -webkit-animation: heading;\n            animation: heading;\n    -webkit-animation-duration: 3s;\n            animation-duration: 3s;\n    -webkit-animation-fill-mode: forwards;\n            animation-fill-mode: forwards;\n    position: relative;\n}\n\n@-webkit-keyframes heading {\n    0% {opacity:0}\n    100% {opacity:1}\n}\n\n@keyframes heading {\n    0% {opacity:0}\n    100% {opacity:1}\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/notes/notes.component.css
// module id = ./src/app/notes/notes.component.css
// module chunks = main